import { createFileRoute } from "@tanstack/react-router";

import { ShowsLibrary } from "@/components/admin/library-pages";

export const Route = createFileRoute("/admin/shows")({
  component: ShowsLibrary,
  head: () => ({ meta: [{ title: "Shows" }] }),
});
